(function($, Drupal) {
  'use strict';

  Drupal.behaviors.alert_position = {
    attach: function(context, settings) {
      const $message_banner = $('#message-banner');
      const $site_header = $('#site-header');

      if ($message_banner) {
        $message_banner.prependTo($site_header);
      }
    }
  };
})(jQuery, Drupal);
